import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

/**
 * Update the status of a user request.
 * Call: mutate({ requestId, status })
 */
export function useUpdateRequestStatus() {
  const { privateFetch } = useContext(FetchContext);
  const qc = useQueryClient();

  return useMutation(
    ({ requestId, status }) =>
      privateFetch.patch(`/v1/admin/podcast/user-requests/${requestId}/status`, { status }),
    {
      onSettled: () => qc.invalidateQueries('admin-user-requests'),
    }
  );
}

/**
 * Soft-delete a user request.
 * Call: mutate(requestId)
 */
export function useDeleteUserRequest() {
  const { privateFetch } = useContext(FetchContext);
  const qc = useQueryClient();

  return useMutation(
    (requestId) => privateFetch.delete(`/v1/admin/podcast/user-requests/${requestId}`),
    {
      onSettled: () => qc.invalidateQueries('admin-user-requests'),
    }
  );
}
